import { NgModule } from '@angular/core';

import { MwTitleCasePipe } from './title-case.pipe';

@NgModule({
  declarations: [MwTitleCasePipe],
  imports: [],
  exports: [MwTitleCasePipe],
})
export class MwSharedPipesModule {}
